
















import {Vue, Component} from "vue-property-decorator";
import store from '@/store';

@Component
export default class SelectSection extends Vue {
    //public progress: string | null | undefined;

    pushInput(){
        store.dispatch('users/pushProgress', 'input');
    }

    toPasswordChange() {
        location.href = String(process.env.VUE_APP_LOCATION_AUTH_PASSWORD_CHANGE_PAGE) + "?referer=" + location.href;
    }

    toCreditCardChange(){
        this.$router.push('change-credit');
    }
}
